import { makeStyles } from '@material-ui/core';
import { ReactNode, useMemo } from 'react';

import { DiagramContextProvider } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/contexts/DiagramContext';
import { useDiagramColors } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/hooks/useDiagramColors';
import { ArrowTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/ArrowTone';

interface DiagramProps {
  viewBox: string;
  children: ReactNode;
}

const useStyles = makeStyles({
  svg: { display: 'block', maxWidth: 420 },
});

let diagramCount = 0;

export const Diagram = ({ viewBox, children }: DiagramProps) => {
  const classes = useStyles();
  const colors = useDiagramColors();
  const markerId = useMemo(() => `orchestration-diagram-${(diagramCount += 1)}`, []);

  return (
    <DiagramContextProvider value={{ colors, markerId }}>
      <svg viewBox={viewBox} width="100%" className={classes.svg} fontFamily="inherit" aria-hidden="true">
        <defs>
          {Object.values(ArrowTone).map((tone) => (
            <marker
              key={tone}
              id={`${markerId}-${tone}`}
              viewBox="0 0 10 10"
              refX="9"
              refY="5"
              markerWidth="7"
              markerHeight="7"
              orient="auto"
            >
              <path d="M0,0 L10,5 L0,10 z" fill={colors.arrow[tone]} />
            </marker>
          ))}
        </defs>
        {children}
      </svg>
    </DiagramContextProvider>
  );
};
